import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword
} from "firebase/auth";
import {
  getFirestore,
  setDoc,
  doc
} from "firebase/firestore";

// 🔐 Firebase yapılandırman
const firebaseConfig = {
  apiKey: "AIzaSyAXV9hxt3AwQPEnHMF4LwDmM412MAxZ36U",
  authDomain: "ustmas-panel.firebaseapp.com",
  projectId: "ustmas-panel",
  storageBucket: "ustmas-panel.firebasestorage.app",
  messagingSenderId: "212536895603",
  appId: "1:212536895603:web:90819c4bc3eb2b8be12206"
};

// 🔌 Uygulamayı başlat
const appName = "mazot-takip";
const app = getApps().find((existingApp) => existingApp.name === appName) || initializeApp(firebaseConfig, appName);

// 🔐 Ana ve ikincil bağlantılar
export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ İkinci bağlantı ile kullanıcı oluşturma (admin'i çıkış yaptırmaz)
const secondaryAppName = "mazot-takip-secondary";
const secondaryApp = getApps().find((existingApp) => existingApp.name === secondaryAppName) || initializeApp(firebaseConfig, secondaryAppName);
const secondaryAuth = getAuth(secondaryApp);

export const createNewUser = async (email, password, role) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);

    await setDoc(doc(db, "users", email), {
      email,
      role,
      active: true
    });

    await secondaryAuth.signOut();
    return { success: true };
  } catch (error) {
    console.error("Yeni kullanıcı oluşturma hatası:", error.message);
    return { success: false, error: error.message };
  }
};

export const deactivateUser = async (email) => {
  try {
    await setDoc(doc(db, "users", email), { active: false }, { merge: true });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
};
